
(() => {
  const root = document.getElementById('s7g');
  if (!root) return;
  const galleryNode = root.querySelector('#s7g-gallery-data');
  const commerceNode = root.querySelector('#s7g-commerce-data') || document.getElementById('s7g-commerce-data');
  const gallery = galleryNode ? JSON.parse(galleryNode.textContent) : [];
  const commerce = commerceNode ? JSON.parse(commerceNode.textContent) : {variants:[], planId:null};
  const moneyFromCents = (cents) => new Intl.NumberFormat('de-DE', {style:'currency', currency:'EUR'}).format((cents || 0) / 100);
  const main = root.querySelector('#main-image');
  const thumbs = root.querySelector('.gallery-thumbnails');
  let galleryIndex = 0;

  function paintLayers(container, item) {
    if (!container || !item) return;
    container.querySelectorAll('.art-layer,.art-table').forEach((el) => el.remove());
    for (const data of item.tables || []) {
      const table = document.createElement('table');
      table.className = 'art-table';
      table.setAttribute('aria-label', data.color === '#01387a' ? 'Wirkstoffe pro Portion' : 'Nährwerte pro Portion');
      if (container.classList.contains('thumbnail-image')) table.setAttribute('aria-hidden', 'true');
      table.style.left = (data.x / 20) + '%';
      table.style.top = (data.y / 20) + '%';
      table.style.width = (data.width / 20) + '%';
      table.style.height = (data.height / 20) + '%';
      table.style.color = data.color;
      table.style.fontSize = (data.fontSize / 20) + 'cqw';
      const body = document.createElement('tbody');
      data.rows.forEach((row) => {
        const tr = document.createElement('tr');
        tr.style.height = (100 / data.rows.length) + '%';
        tr.style.fontWeight = row.weight || 700;
        const label = document.createElement('th');
        label.scope = 'row';
        label.textContent = row.label;
        const value = document.createElement('td');
        value.textContent = row.value;
        tr.append(label, value);
        body.append(tr);
      });
      table.append(body);
      container.append(table);
    }
  }

  function selectImage(index, focus) {
    if (!gallery.length || !main || !thumbs) return;
    galleryIndex = (index + gallery.length) % gallery.length;
    const item = gallery[galleryIndex];
    main.src = item.src;
    main.alt = item.alt || item.caption;
    paintLayers(root.querySelector('.gallery-art'), item);
    const buttons = [...thumbs.children];
    buttons.forEach((b, i) => b.setAttribute('aria-pressed', String(i === galleryIndex)));
    const active = buttons[galleryIndex];
    if (focus) active.focus({preventScroll: true});
    thumbs.scrollTo({
      left: Math.max(0, active.offsetLeft - thumbs.offsetLeft - (thumbs.clientWidth - active.clientWidth) / 2),
      behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'
    });
  }

  if (main && thumbs && gallery.length) {
    gallery.forEach((item, index) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', item.caption);
      b.setAttribute('aria-pressed', String(index === 0));
      const face = document.createElement('span');
      face.className = 'thumbnail-image';
      const im = document.createElement('img');
      im.src = item.src;
      im.alt = '';
      im.loading = index < 6 ? 'eager' : 'lazy';
      face.append(im);
      paintLayers(face, item);
      const caption = document.createElement('span');
      caption.className = 'thumbnail-caption';
      caption.textContent = item.caption;
      b.append(face, caption);
      b.addEventListener('click', () => selectImage(index));
      b.addEventListener('keydown', (e) => {
        if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(e.key)) {
          e.preventDefault();
          selectImage(e.key === 'Home' ? 0 : e.key === 'End' ? gallery.length - 1 : index + (e.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      thumbs.append(b);
    });
    selectImage(0);
    root.querySelector('.gallery-prev')?.addEventListener('click', () => selectImage(galleryIndex - 1));
    root.querySelector('.gallery-next')?.addEventListener('click', () => selectImage(galleryIndex + 1));
    let touchStart = null;
    main.addEventListener('touchstart', (e) => {
      touchStart = {x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY};
    }, {passive: true});
    main.addEventListener('touchend', (e) => {
      if (!touchStart) return;
      const dx = e.changedTouches[0].clientX - touchStart.x;
      const dy = e.changedTouches[0].clientY - touchStart.y;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) selectImage(galleryIndex + (dx < 0 ? 1 : -1));
      touchStart = null;
    }, {passive: true});
  }

  const variants = commerce.variants || [];
  const form = root.querySelector('#purchase-options');
  const addButton = root.querySelector('.add-button');
  const status = root.querySelector('[data-s7g-cart-status]');
  let mode = 'subscription';
  const selectedVariant = () => {
    const checked = form?.querySelector('[name="offer"]:checked');
    const id = checked ? Number(checked.value) : variants[0]?.id;
    return variants.find((item) => item.id === id) || variants[0] || null;
  };

  function refreshOnetime() {
    const variant = selectedVariant();
    if (!variant) return;
    const total = root.querySelector('#total-price');
    const unit = root.querySelector('#unit-price');
    const ship = root.querySelector('#shipping-terms');
    if (total) total.textContent = variant.priceMoney;
    if (unit) unit.textContent = variant.unitMoney;
    if (ship) ship.textContent = variant.freeShipping ? 'Versandkostenfrei' : 'zzgl. Versandkosten';
  }

  form?.addEventListener('change', (e) => {
    if (e.target.name === 'offer') refreshOnetime();
    if (e.target.name === 'purchase-mode') {
      mode = e.target.value;
      root.querySelectorAll('.purchase-mode').forEach((card) => {
        const active = card.dataset.mode === mode;
        card.classList.toggle('is-active', active);
        const body = card.querySelector('.mode-body');
        if (body) body.hidden = !active;
        if (active && addButton) card.querySelector('.cart-slot')?.append(addButton);
      });
    }
  });

  async function openThemeCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
    document.dispatchEvent(new CustomEvent('variant:add', {bubbles: true, detail: {}}));
    const drawer = document.querySelector('cart-drawer, cart-notification, #cart-drawer, [data-cart-drawer]');
    if (drawer) {
      if (typeof drawer.show === 'function') drawer.show();
      else if (typeof drawer.open === 'function') drawer.open();
      else drawer.setAttribute('open', '');
      return true;
    }
    const toggle = document.querySelector('[data-drawer="cart"], [aria-controls*="cart"]');
    if (toggle) {
      toggle.click();
      return true;
    }
    return false;
  }

  async function addSelectedToCart(e) {
    e.preventDefault();
    e.stopPropagation();
    const variant = selectedVariant() || variants[0];
    if (!variant || !addButton) return;
    const fd = new URLSearchParams();
    fd.append('id', variant.id);
    fd.append('quantity', 1);
    if (mode === 'subscription' && commerce.planId) fd.append('selling_plan', Number(commerce.planId));
    addButton.disabled = true;
    if (status) status.textContent = '';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json'},
        body: fd.toString()
      });
      if (!res.ok) throw new Error('add-failed');
      const opened = await openThemeCart();
      if (!opened) window.location.href = '/cart';
    } catch (err) {
      if (status) status.textContent = 'Der Artikel konnte nicht hinzugefügt werden. Bitte versuchen Sie es erneut.';
    } finally {
      addButton.disabled = false;
    }
  }
  form?.addEventListener('submit', addSelectedToCart, true);
  addButton?.addEventListener('click', addSelectedToCart);

  root.querySelector('.subscription-more')?.addEventListener('click', () => root.querySelector('#subscription-dialog')?.showModal());
  root.querySelectorAll('.close-dialog').forEach((b) => b.addEventListener('click', () => b.closest('dialog')?.close()));
  root.querySelectorAll('dialog').forEach((d) => d.addEventListener('click', (e) => {
    if (e.target === d) {
      const r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
    }
  }));
  const imageDialog = root.querySelector('#image-dialog');
  root.querySelector('.gallery-zoom')?.addEventListener('click', () => {
    const detail = root.querySelector('#detail-image');
    if (detail && main) {
      detail.src = main.src;
      detail.alt = main.alt;
    }
    paintLayers(root.querySelector('.detail-art'), gallery[galleryIndex]);
    root.querySelector('.detail-scroll')?.classList.remove('is-zoomed');
    const zoom = root.querySelector('#detail-zoom');
    if (zoom) {
      zoom.setAttribute('aria-pressed', 'false');
      zoom.textContent = 'Details vergrößern +';
    }
    imageDialog?.showModal();
  });
  root.querySelector('#detail-zoom')?.addEventListener('click', (e) => {
    const zoomed = root.querySelector('.detail-scroll')?.classList.toggle('is-zoomed');
    e.currentTarget.setAttribute('aria-pressed', String(!!zoomed));
    e.currentTarget.textContent = zoomed ? 'Gesamtbild ansehen −' : 'Details vergrößern +';
  });
  document.title = 'Knorpel Komplex Forte · 5 Gründe | Wehle';
})();

(() => { if (!document.getElementById('s7g')) return;
(() => {
  const section = document.querySelector('.formula-section');
  const composition = section.querySelector('.formula-composition');
  const track = section.querySelector('.ingredient-track');
  const cards = [...section.querySelectorAll('.ingredient')];
  const dots = [...section.querySelectorAll('[data-select]')];
  const mobile = matchMedia('(max-width:1000px)');
  const reducedMotion = matchMedia('(prefers-reduced-motion:reduce)');
  let active = 'collagen';
  let frame;
  function update(id) {
    active = id;
    composition.dataset.active = id;
    cards.forEach(card => card.classList.toggle('is-active', card.dataset.ingredient === id));
    dots.forEach(dot => {
      const selected = dot.dataset.select === id;
      dot.classList.toggle('is-active', selected);
      dot.setAttribute('aria-pressed', String(selected));
    });
    const index = cards.findIndex(card => card.dataset.ingredient === id);
    section.querySelector('[data-direction="-1"]').disabled = index === 0;
    section.querySelector('[data-direction="1"]').disabled = index === cards.length - 1;
  }
  function select(id) {
    update(id);
    if (!mobile.matches) return;
    const card = cards.find(item => item.dataset.ingredient === id);
    track.scrollTo({left:card.offsetLeft - cards[0].offsetLeft, behavior:reducedMotion.matches ? 'instant' : 'smooth'});
  }
  dots.forEach(dot => dot.addEventListener('click', () => select(dot.dataset.select)));
  section.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
    const index = cards.findIndex(card => card.dataset.ingredient === active);
    const next = Math.max(0, Math.min(cards.length - 1, index + Number(button.dataset.direction)));
    select(cards[next].dataset.ingredient);
  }));
  track.addEventListener('scroll', () => {
    if (!mobile.matches) return;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const distance = card => Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft);
      const nearest = cards.reduce((a,b) => distance(a) < distance(b) ? a : b);
      update(nearest.dataset.ingredient);
    });
  }, {passive:true});
  mobile.addEventListener('change', () => {
    if (mobile.matches) select(active);
  });
  update(active);
})();

})();

(() => { if (!document.getElementById('s7g')) return;
(() => {
  document.querySelectorAll('.testimonials-section').forEach((section) => {
    const track = section.querySelector('[data-testimonials-track]');
    const navigation = section.querySelector('[data-testimonials-navigation]');
    if (!track || !navigation || track.dataset.navigationReady === 'true') return;
    const cards = Array.from(track.children);
    const previous = section.querySelector('[data-testimonials-previous]');
    const next = section.querySelector('[data-testimonials-next]');
    const current = section.querySelector('[data-testimonials-current]');
    const total = section.querySelector('[data-testimonials-total]');
    const filters = section.querySelector('[data-testimonials-filters]');
    const filterButtons = Array.from(section.querySelectorAll('[data-testimonials-filter]'));
    if (!cards.length || !previous || !next || !current) return;
    track.dataset.navigationReady = 'true';
    let visibleCards = cards.filter(card => !card.hidden);
    let selected = 0;
    let frame = 0;

    const positions = () => {
      const first = visibleCards[0]?.getBoundingClientRect().left ?? 0;
      return visibleCards.map(card => card.getBoundingClientRect().left - first);
    };
    const update = () => {
      frame = 0;
      const distances = positions().map(left => Math.abs(left - track.scrollLeft));
      const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const scrollable = maximumScroll > 1;
      selected = !scrollable ? 0 : track.scrollLeft >= maximumScroll - 1
        ? visibleCards.length - 1
        : distances.indexOf(Math.min(...distances));
      previous.disabled = !scrollable || selected <= 0;
      next.disabled = !scrollable || selected >= visibleCards.length - 1;
      navigation.hidden = visibleCards.length < 2 || !scrollable;
      current.textContent = String(visibleCards.length ? selected + 1 : 0).padStart(2, '0');
      if (total) total.textContent = String(visibleCards.length).padStart(2, '0');
    };
    const go = (index) => {
      if (!visibleCards.length) return;
      const target = Math.max(0, Math.min(visibleCards.length - 1, index));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: positions()[target], behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    const revealSelectedFilter = (button) => {
      if (!filters || !button || filters.scrollWidth <= filters.clientWidth + 1) return;
      const desired = button.getBoundingClientRect().left - filters.getBoundingClientRect().left
        + filters.scrollLeft - (filters.clientWidth - button.getBoundingClientRect().width) / 2;
      filters.scrollTo({ left: Math.max(0, Math.min(filters.scrollWidth - filters.clientWidth, desired)), behavior: 'auto' });
    };
    const filter = (key) => {
      const selectedButton = filterButtons.find(button => button.dataset.testimonialsFilter === key);
      if (!selectedButton) return;
      cards.forEach(card => {
        card.hidden = !(card.dataset.testimonialTopics || '').split(' ').includes(key);
      });
      visibleCards = cards.filter(card => !card.hidden);
      filterButtons.forEach(button => button.setAttribute('aria-pressed', String(button === selectedButton)));
      track.dataset.activeFilter = key;
      track.dataset.visibleCount = String(visibleCards.length);
      track.setAttribute('aria-label', `${selectedButton.textContent.trim()}: ${visibleCards.length} Kundenbewertungen`);
      selected = 0;
      track.scrollTo({ left: 0, behavior: 'auto' });
      revealSelectedFilter(selectedButton);
      update();
    };
    if (filters && filterButtons.length) {
      filters.hidden = false;
      filterButtons.forEach(button => button.addEventListener('click', () => filter(button.dataset.testimonialsFilter)));
      filters.addEventListener('keydown', (event) => {
        const index = filterButtons.indexOf(event.target);
        if (index < 0) return;
        const targets = { ArrowLeft: (index + filterButtons.length - 1) % filterButtons.length, ArrowRight: (index + 1) % filterButtons.length, Home: 0, End: filterButtons.length - 1 };
        if (!(event.key in targets)) return;
        event.preventDefault();
        const button = filterButtons[targets[event.key]];
        button.focus({ preventScroll: true });
        revealSelectedFilter(button);
      });
      const chosen = track.dataset.defaultFilter
        || filterButtons.find(button => button.getAttribute('aria-pressed') === 'true')?.dataset.testimonialsFilter
        || filterButtons[0].dataset.testimonialsFilter;
      filter(chosen);
    }
    previous.addEventListener('click', () => go(selected - 1));
    next.addEventListener('click', () => go(selected + 1));
    track.addEventListener('keydown', (event) => {
      if (event.target !== track || track.scrollWidth <= track.clientWidth + 1) return;
      const targets = { ArrowLeft: selected - 1, ArrowRight: selected + 1, Home: 0, End: visibleCards.length - 1 };
      if (!(event.key in targets)) return;
      event.preventDefault();
      go(targets[event.key]);
    });
    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', () => {
      revealSelectedFilter(filterButtons.find(button => button.getAttribute('aria-pressed') === 'true'));
      schedule();
    }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(track);
    document.fonts?.ready.then(() => {
      revealSelectedFilter(filterButtons.find(button => button.getAttribute('aria-pressed') === 'true'));
      schedule();
    });
    update();
  });
})();

})();

(() => { if (!document.getElementById('s7g')) return;
(() => {
  document.querySelector('.closing-cta').addEventListener('click', event => {
    event.preventDefault();
    const form = document.querySelector('#purchase-options');
    history.replaceState(null, '', '#purchase-options');
    form.querySelector('[name="purchase-mode"]:checked').focus({preventScroll:true});
    form.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
  });
})();

})();

(() => { if (!document.getElementById('s7g')) return;
(()=>{
  const gallery=document.querySelector('#buybox .product-gallery');
  const copy=document.querySelector('#buybox .product-copy');
  const stage=gallery?.querySelector('.gallery-stage');
  const thumbs=gallery?.querySelector('.gallery-thumbnails');
  const eyebrow=copy?.querySelector(':scope > .eyebrow');
  if(!gallery||!stage||!thumbs||!eyebrow||gallery.dataset.mgv6Mounted)return;
  gallery.dataset.mgv6Mounted='true';

  const mobile=matchMedia('(max-width:699px)');
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  const originalPosition=document.createComment('Mobile eyebrow returns here above 699px.');
  eyebrow.before(originalPosition);
  const track=document.createElement('div');
  track.className='mgv6-track';
  track.tabIndex=0;
  track.setAttribute('role','region');
  track.setAttribute('aria-roledescription','Karussell');
  track.setAttribute('aria-label','Produktbilder. Mit den Pfeiltasten das Bild wechseln.');
  const status=document.createElement('p');
  status.className='mgv6-status visually-hidden';
  status.setAttribute('role','status');
  status.setAttribute('aria-live','polite');
  status.setAttribute('aria-atomic','true');
  // Keep the original .gallery-art first: the existing controller renders into it.
  stage.append(track);
  gallery.append(status);
  let suppressBaseIndex=null;
  let requestedIndex=null;
  let touchActive=false;
  let settleTimer;
  let alignmentFrame;

  const buttons=()=>[...thumbs.querySelectorAll(':scope > button')];
  const selected=()=>Math.max(0,buttons().findIndex(button=>button.getAttribute('aria-pressed')==='true'));
  const bounded=index=>Math.max(0,Math.min(track.children.length-1,index));
  const targetLeft=index=>{
    const slide=track.children[bounded(index)];
    return slide?slide.offsetLeft-(track.clientWidth-slide.clientWidth)/2:0;
  };
  const nearest=()=>{
    let best=0,distance=Infinity;
    [...track.children].forEach((slide,index)=>{
      const delta=Math.abs(targetLeft(index)-track.scrollLeft);
      if(delta<distance){best=index;distance=delta;}
    });
    return best;
  };
  function mark(index){
    track.dataset.activeIndex=String(index);
    [...track.children].forEach((slide,i)=>slide.classList.toggle('is-active',i===index));
    const caption=buttons()[index]?.getAttribute('aria-label')||'';
    status.textContent=`Bild ${index+1} von ${track.children.length}: ${caption}`;
  }
  function align(index,behavior='auto'){
    if(!mobile.matches||!track.children.length)return;
    requestedIndex=index;
    track.scrollTo({left:targetLeft(index),behavior:reduced.matches?'auto':behavior});
    mark(index);
  }
  function selectThroughOriginal(index){
    const button=buttons()[index];
    if(!button)return;
    if(index!==selected()){
      suppressBaseIndex=index;
      // Reuse the original selection, nutrition rendering, zoom and thumb state.
      button.click();
    }
    mark(index);
  }
  function settle(){
    clearTimeout(settleTimer);
    if(!mobile.matches||touchActive||!track.children.length)return;
    // A cancelled smooth-scroll event must not undo a newer keyboard/thumb target.
    if(requestedIndex!==null&&Math.abs(targetLeft(requestedIndex)-track.scrollLeft)>2)return;
    requestedIndex=null;
    selectThroughOriginal(nearest());
  }
  function queueSettle(){
    clearTimeout(settleTimer);
    settleTimer=setTimeout(settle,140);
  }
  function build(){
    const originals=buttons();
    if(!mobile.matches||!originals.length||track.children.length===originals.length)return;
    const slides=originals.map((button,index)=>{
      const originalArt=button.querySelector('.thumbnail-image');
      if(!originalArt)return null;
      const slide=document.createElement('div');
      slide.className='mgv6-slide';
      slide.dataset.index=String(index);
      slide.setAttribute('role','group');
      slide.setAttribute('aria-label',`${index+1} von ${originals.length}`);
      // Clone the already-approved rendering, including its exact layers/tables.
      const art=originalArt.cloneNode(true);
      art.className='gallery-art mgv6-art';
      const image=art.querySelector(':scope > img');
      image.classList.add('mgv6-image');
      image.alt=button.getAttribute('aria-label')||'';
      image.draggable=false;
      image.loading=index<3?'eager':'lazy';
      art.querySelectorAll('.art-table').forEach(table=>table.removeAttribute('aria-hidden'));
      slide.append(art);
      return slide;
    });
    if(slides.some(slide=>!slide))return;
    track.replaceChildren(...slides);
    gallery.classList.add('mgv6-ready');
    requestAnimationFrame(()=>align(selected()));
  }
  function setMode(){
    clearTimeout(settleTimer);
    touchActive=false;
    requestedIndex=null;
    if(mobile.matches){
      gallery.insertBefore(eyebrow,stage);
      build();
      requestAnimationFrame(()=>align(selected()));
    }else{
      originalPosition.after(eyebrow);
    }
  }

  track.addEventListener('scroll',queueSettle,{passive:true});
  track.addEventListener('scrollend',settle);
  track.addEventListener('wheel',()=>{requestedIndex=null;},{passive:true});
  track.addEventListener('touchstart',()=>{touchActive=true;requestedIndex=null;clearTimeout(settleTimer);},{passive:true});
  track.addEventListener('touchend',()=>{touchActive=false;queueSettle();},{passive:true});
  track.addEventListener('touchcancel',()=>{touchActive=false;queueSettle();},{passive:true});
  track.addEventListener('keydown',event=>{
    if(!mobile.matches||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
    event.preventDefault();
    const index=bounded(event.key==='Home'?0:event.key==='End'?track.children.length-1:selected()+(event.key==='ArrowRight'?1:-1));
    selectThroughOriginal(index);
    align(index,'smooth');
  });
  stage.addEventListener('click',event=>{
    if(mobile.matches&&event.target.closest('.gallery-zoom')){
      if(requestedIndex!==null)selectThroughOriginal(requestedIndex);
      else settle();
    }
  },true);
  new MutationObserver(()=>{
    build();
    const index=selected();
    if(suppressBaseIndex===index){suppressBaseIndex=null;return;}
    if(mobile.matches&&!touchActive)align(index,'smooth');
  }).observe(thumbs,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-pressed']});
  new ResizeObserver(()=>{
    cancelAnimationFrame(alignmentFrame);
    alignmentFrame=requestAnimationFrame(()=>{if(!touchActive)align(selected());});
  }).observe(gallery);
  mobile.addEventListener('change',setMode);
  setMode();
})();

})();

(() => { if (!document.getElementById('s7g')) return;
(()=>{
 const track=document.querySelector('#expert .authority-background > ul.authority-credentials');
 if(!track||track.dataset.authorityCarousel)return;
 const cards=[...track.children];if(cards.length<2)return;
 const region=track.parentElement,phone=matchMedia('(max-width:699px)'),reduce=matchMedia('(prefers-reduced-motion:reduce)');
 const interval=4800;
 const controls=document.createElement('div');controls.className='authority-carousel-controls';controls.setAttribute('role','group');controls.setAttribute('aria-label','Beruflichen Hintergrund durchblättern');
 const dots=document.createElement('div');dots.className='authority-carousel-dots';
 const toggle=document.createElement('button');toggle.type='button';toggle.className='authority-carousel-toggle';
 const buttons=cards.map((card,index)=>{
  const button=document.createElement('button');button.type='button';button.className='authority-carousel-dot';
  button.setAttribute('aria-label',`${index+1} von ${cards.length}: ${card.querySelector('strong')?.textContent.trim()||'Beruflicher Hintergrund'}`);
  button.addEventListener('click',()=>{defer();go(index,false);});dots.append(button);return button;
 });
 controls.append(dots,toggle);track.after(controls);track.dataset.authorityCarousel='true';
 let current=0,userPaused=false,hovered=false,focused=false,touching=false,resumeAt=0,timer=0,raf=0;
 const worlds=[];let realm=window;
 while(realm){worlds.push(realm);try{if(realm===realm.parent)break;realm=realm.parent;void realm.document;}catch{break;}}
 const intersect=(a,b)=>({left:Math.max(a.left,b.left),right:Math.min(a.right,b.right),top:Math.max(a.top,b.top),bottom:Math.min(a.bottom,b.bottom)});
 const positive=r=>r.right>r.left&&r.bottom>r.top;
 const clamp=(value,min,max)=>Math.max(min,Math.min(max,value));
 // Convert the visible card strip through same-origin iframe transforms and clip
 // against each real browser viewport. Full-page review iframe height is not visibility.
 function visible(){
  let r=track.getBoundingClientRect();const original={width:r.width,height:r.height};
  if(!r.width||!r.height)return false;
  r={left:r.left,right:r.right,top:r.top,bottom:r.bottom};let win=window,node=track,scaleArea=1;
  try{
   while(true){
    if(win.document.visibilityState!=='visible'||win.document.querySelector('dialog[open]'))return false;
    const viewport=win.visualViewport;
    r=intersect(r,{left:viewport?.offsetLeft||0,top:viewport?.offsetTop||0,right:(viewport?.offsetLeft||0)+(viewport?.width||win.innerWidth),bottom:(viewport?.offsetTop||0)+(viewport?.height||win.innerHeight)});
    for(let ancestor=node.parentElement;ancestor;ancestor=ancestor.parentElement){
     const style=win.getComputedStyle(ancestor),box=ancestor.getBoundingClientRect();
     if(/hidden|clip|scroll|auto/.test(style.overflowX))r=intersect(r,{left:box.left,right:box.right,top:-Infinity,bottom:Infinity});
     if(/hidden|clip|scroll|auto/.test(style.overflowY))r=intersect(r,{left:-Infinity,right:Infinity,top:box.top,bottom:box.bottom});
    }
    // The review's sticky device toolbar covers part of its parent viewport.
    if(win!==window&&win.document.querySelector('.preview-stage iframe')){
     const bar=win.document.querySelector('.toolbar');if(bar){const b=bar.getBoundingClientRect();if(b.top<=0&&b.bottom>0)r.top=Math.max(r.top,b.bottom);}
    }
    if(!positive(r))return false;
    if(win===win.parent)break;
    const frame=win.frameElement;if(!frame)return false;
    const box=frame.getBoundingClientRect(),sx=box.width/frame.offsetWidth,sy=box.height/frame.offsetHeight;
    if(!sx||!sy)return false;
    const left=box.left+frame.clientLeft*sx,top=box.top+frame.clientTop*sy;
    r={left:left+r.left*sx,right:left+r.right*sx,top:top+r.top*sy,bottom:top+r.bottom*sy};scaleArea*=sx*sy;
    node=frame;win=win.parent;
   }
  }catch{return false;}
  return (r.right-r.left)*(r.bottom-r.top)>=original.width*original.height*scaleArea*.65;
 }
 function targets(){
  const box=track.getBoundingClientRect(),max=Math.max(0,track.scrollWidth-track.clientWidth);
  return cards.map(card=>{const r=card.getBoundingClientRect();return clamp(track.scrollLeft+r.left-box.left-(track.clientWidth-r.width)/2,0,max);});
 }
 function nearest(){const points=targets();return points.reduce((best,value,index)=>Math.abs(value-track.scrollLeft)<Math.abs(points[best]-track.scrollLeft)?index:best,0);}
 function paint(){
  buttons.forEach((button,index)=>button.setAttribute('aria-pressed',String(index===current)));
  toggle.textContent=userPaused?'Abspielen':'Pause';toggle.setAttribute('aria-label',userPaused?'Automatischen Wechsel abspielen':'Automatischen Wechsel pausieren');
  toggle.setAttribute('aria-pressed',String(!userPaused));toggle.hidden=reduce.matches;
 }
 function state(){
  if(!phone.matches)return 'desktop';if(reduce.matches)return 'reduced-motion';
  if(track.scrollWidth<=track.clientWidth+2)return 'fits';if(userPaused)return 'paused';
  if(hovered||focused||touching)return 'interaction';if(performance.now()<resumeAt)return 'waiting';
  if(!visible())return 'offscreen';return 'playing';
 }
 function sync(){
  controls.hidden=!phone.matches||track.scrollWidth<=track.clientWidth+2;
  if(phone.matches)track.tabIndex=0;else track.removeAttribute('tabindex');
  const status=state();track.dataset.authorityPlayback=status;paint();
  if(status!=='playing'){clearTimeout(timer);timer=0;
   if(status==='waiting')timer=setTimeout(()=>{timer=0;sync();},Math.max(30,resumeAt-performance.now()));
   return;
  }
  if(!timer)timer=setTimeout(()=>{timer=0;if(state()==='playing'){go((current+1)%cards.length,true);}sync();},interval);
 }
 function schedule(){if(!raf)raf=requestAnimationFrame(()=>{raf=0;sync();});}
 function defer(){resumeAt=performance.now()+interval;clearTimeout(timer);timer=0;schedule();}
 function go(index,automatic){current=index;track.scrollTo({left:targets()[index],behavior:reduce.matches?'instant':'smooth'});paint();if(!automatic)defer();}
 toggle.addEventListener('click',()=>{userPaused=!userPaused;if(!userPaused){focused=false;resumeAt=0;}sync();});
 region.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'&&matchMedia('(hover:hover)').matches){hovered=true;sync();}});
 region.addEventListener('pointerleave',()=>{hovered=false;sync();});
 region.addEventListener('focusin',()=>{focused=true;sync();});
 region.addEventListener('focusout',()=>requestAnimationFrame(()=>{focused=region.contains(document.activeElement);sync();}));
 track.addEventListener('pointerdown',()=>{touching=true;defer();sync();},{passive:true});
 const release=()=>{if(touching){touching=false;defer();sync();}};
 window.addEventListener('pointerup',release,{passive:true});window.addEventListener('pointercancel',release,{passive:true});
 track.addEventListener('wheel',defer,{passive:true});
 track.addEventListener('scroll',()=>{current=nearest();paint();},{passive:true});
 track.addEventListener('keydown',event=>{
  if(!phone.matches)return;
  const index=event.key==='ArrowRight'?Math.min(current+1,cards.length-1):event.key==='ArrowLeft'?Math.max(current-1,0):event.key==='Home'?0:event.key==='End'?cards.length-1:null;
  if(index!==null){event.preventDefault();defer();go(index,false);}
 });
 phone.addEventListener('change',schedule);reduce.addEventListener('change',schedule);
 worlds.forEach(win=>{try{win.addEventListener('scroll',schedule,{passive:true,capture:true});win.addEventListener('resize',schedule);win.document.addEventListener('visibilitychange',schedule);win.visualViewport?.addEventListener('resize',schedule);win.visualViewport?.addEventListener('scroll',schedule);}catch{}});
 const resize=new ResizeObserver(schedule);resize.observe(track);
 const observer=new IntersectionObserver(schedule,{threshold:[0,.65,1]});observer.observe(track);
 // Opening a dialog must immediately pause this independent automatic motion.
 const dialogs=new MutationObserver(schedule);dialogs.observe(document.body,{attributes:true,attributeFilter:['open'],subtree:true});
 sync();
})();

})();
